import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
@ViewChild('navMenu', {static: true}) navMenu: ElementRef;
  openMenu = false;
  heightMenu = 82;
  @ViewChild('navPadding', {static: false}) navPadding: ElementRef;
  isTop = true;
  boxShadow = '0 1px 2px rgba(0, 0, 0, 0.12), 0 0px 10px rgba(0, 0, 0, 0.08)';

  constructor(
    private navigationService: NavigationService
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.heightMenu = this.navMenu.nativeElement.offsetHeight;
      this.navigationService.padding = this.heightMenu;
    }, 10);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    this.isTop = window.scrollY === 0 ? true : false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.heightMenu = this.navMenu.nativeElement.offsetHeight;
    this.navigationService.padding = this.heightMenu;
  }

  toggleMenu(): void {
    this.openMenu = this.openMenu ? false : true;
  }

  goTo(route: string): void {
    this.navigationService.scrollSection(route);
    this.openMenu = false;
  }

  isActive(route: string): boolean {
    if (!this.navigationService.currentUrl && route === '') {
      return true;
    }
    return this.navigationService.currentUrl === route ? true : false;
  }
}
